import { render, staticRenderFns } from "./educate.vue?vue&type=template&id=5db8a92a&scoped=true"
import script from "./educate.vue?vue&type=script&lang=js"
export * from "./educate.vue?vue&type=script&lang=js"
import style0 from "./educate.vue?vue&type=style&index=0&id=5db8a92a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db8a92a",
  null
  
)

export default component.exports